export const AmenityBookingWindow = {
    OneYear: 365,
    NineMonths: 270,
    SixMonths: 180,
    ThreeMonths: 90
}